import { store } from '../store'
import { PricingEnum } from '../enums/modules/routes'
import { BaseRouteEnum } from '@/enums/modules/routes'
import PricingRoot from '../components/micro-front-ends/Pricing'
import Pricing from '../components/pricing/Pricing'

export default [
  {
    path: '/Pricing*',
    name: PricingEnum.Pricing,
    component: {
      render (createElement) {
        const ComponentToRender = store.getters.enableNewPricingUI ? PricingRoot : Pricing
        return createElement(ComponentToRender)
      }
    },
    beforeEnter (_to, _from, next) {
      // if a subaccount user of a powered by account tries to load pricing information
      // redirect them to the Dashboard instead
      const { isPoweredBySubAccountUser } = store.getters['user/getExternalIdInfo']
      if (isPoweredBySubAccountUser) {
        next({ name: BaseRouteEnum.DashboardV2 })
      } else {
        next()
      }
    },
    meta: { showSideNav: true }
  }
]
